<div class="floating-input-wrapper"
     [class.focused]="isFocused"
     [class.has-value]="hasValue"
     [class.disabled]="disabled">
  <div class="floating-input-container">
    <input
      ngbDatepicker
      #datepickeritem="ngbDatepicker"
      id="{{field.code}}"
      class="floating-input"
      [ngClass]="ngClass"
      name="{{field.code}}"
      [disabled]="disabled"
      [(ngModel)]="date"
      [maxDate]="maxDate"
      [minDate]="minDate"
      [dayTemplate]="customDay"
      (ngModelChange)="onChange($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (keypress)="$event.preventDefault()"
      (keydown)="$event.preventDefault()"
      (keyup)="$event.preventDefault()"
      (click)="datepickeritem.toggle();"
      autocomplete="false"
      placeholder=" "
    />
    <label class="floating-label" [class.floating]="isFocused || hasValue">
      <img
        src="assets/icons/required-asterisk.svg"
        *ngIf="required"
        [attr.alt]="'alt.requiredField' | translate"
      >
      {{ label || placeholder }}
<!--      <span class="required-asterisk" *ngIf="required"></span>-->
    </label>
  </div>
</div>

<ng-template
  #customDay
  let-date
  let-currentMonth="currentMonth"
  let-selected="selected"
  let-disabled="disabled"
  let-focused="focused"
>
  <span
    class="custom-day"
    [class.weekend]="isWeekend(date)"
    [class.focused]="focused"
    [class.bg-primary]="selected"
    [class.hidden]="date.month !== currentMonth"
    [class.text-muted]="disabled"
  >
    {{ date.day }}
  </span>
</ng-template>
